/* eslint-disable multiline-ternary */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getMyGroups } from '_redux/modules/group'

import GroupItem from '../components/GroupItem'

import '../style.scss'

const GroupList = () => {
  const dispatch = useDispatch()
  const { myGroups } = useSelector((state) => state.group)

  useEffect(() => {
    dispatch(getMyGroups)
    document.body.classList.add('group-list-active')
    return () => {
      document.body.classList.remove('group-list-active')
    }
  }, [])

  if (myGroups === null) return <div>Loading...</div>

  return (
    <div className='view-group-container'>
      <div className='group-search-top'>
        <div className='inner'>
          <span className='grp-lbl'>MY GROUP ({myGroups?.length || 0})</span>
          <Link className='find-group-link' to='/group/find'>
            <svg
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <circle cx='11' cy='11' r='8' />
              <line x1='21' y1='21' x2='16.65' y2='16.65' />
            </svg>
            Find a group to join
          </Link>
        </div>
      </div>

      {/* My groups list */}
      <div className='group-list'>
        {myGroups && myGroups.length > 0 ? (
          myGroups
            .slice()
            .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
            .map((item, index) => (
              <GroupItem key={item.id || index} groupInfo={item} index={index} />
            ))
        ) : (
          <div style={{ padding: '24px 0', textAlign: 'center', color: '#888', fontSize: '13px' }}>
            You don&apos;t have any groups!
          </div>
        )}
      </div>
    </div>
  )
}

export default GroupList
